import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Badge } from "@/components/ui/badge";

const KIND_BG = {
  created: "bg-zinc-100 text-zinc-700",
  updated: "bg-blue-100 text-blue-800",
  approved_internal: "bg-emerald-100 text-emerald-800",
  approved: "bg-emerald-100 text-emerald-800",
  approved_external: "bg-emerald-100 text-emerald-800",
  rejected_external: "bg-red-100 text-red-800",
  initiated: "bg-amber-100 text-amber-800",
  accepted: "bg-emerald-100 text-emerald-800",
  clarification_requested: "bg-orange-100 text-orange-800",
  sent: "bg-blue-100 text-blue-800",
  payment_recorded: "bg-emerald-100 text-emerald-800",
  converted_to_quotation: "bg-purple-100 text-purple-800",
  generated_from_hours: "bg-purple-100 text-purple-800",
  created_via_handover: "bg-purple-100 text-purple-800",
};

export default function AuditLogs() {
  const { data: rows = [] } = useQuery({ queryKey: ["audit"], queryFn: async () => (await api.get("/audit", { params: { limit: 200 } })).data });

  return (
    <div data-testid="audit-page">
      <PageHeader
        eyebrow="Platform · Governance"
        title="Audit Logs"
        description="Every mutating action across the platform. Trace who did what, when, and to which entity — forensic-grade trail per Principle 5."
      />
      <div className="max-w-[1400px] mx-auto px-8 py-6">
        <div className="border border-zinc-200 rounded-lg bg-white overflow-hidden" data-testid="audit-table">
          <table className="w-full text-sm">
            <thead className="bg-zinc-50 border-b border-zinc-200">
              <tr className="text-left text-[10px] uppercase tracking-widest text-zinc-500">
                <th className="px-4 py-3">When</th><th className="px-4 py-3">Actor</th><th className="px-4 py-3">Action</th>
                <th className="px-4 py-3">Entity</th><th className="px-4 py-3">Reference</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-100">
              {rows.map((a) => (
                <tr key={a.id} data-testid={`audit-row-${a.id}`}>
                  <td className="px-4 py-3 font-mono text-[11px] text-zinc-500 whitespace-nowrap">{a.at.slice(0, 16).replace("T", " ")}</td>
                  <td className="px-4 py-3">{a.actor_name || <span className="font-mono text-xs text-zinc-500">{a.actor_user_id}</span>}</td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium uppercase tracking-widest ${KIND_BG[a.action] || "bg-zinc-100 text-zinc-700"}`}>{a.action.replace(/_/g, " ")}</span>
                  </td>
                  <td className="px-4 py-3 capitalize text-zinc-600">{a.entity_kind}</td>
                  <td className="px-4 py-3 font-mono text-xs">{a.entity_label || a.entity_id}</td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-sm text-zinc-500">No audit events yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
